import { Box } from "@chakra-ui/react";
import { PropsWithChildren } from "react";

function PageLayout({ children }: PropsWithChildren) {
  return <Box bg="gray.50" display="grid" gridTemplateRows="auto auto 1fr" minH="100vh" position="relative">{children}</Box>;
}

export default PageLayout;
